import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M5.231 4.002a.75.75 0 0 0-.401.143C2.422 5.905 1 8.672 1 11.612c0 2.941 1.42 5.714 3.83 7.472v.002a.747.747 0 0 0 1.028-.144.71.71 0 0 0-.15-1.006c-2.04-1.489-3.24-3.834-3.24-6.323s1.2-4.828 3.24-6.317a.71.71 0 0 0 .151-1.006A.74.74 0 0 0 5.23 4m13.541 0a.736.736 0 0 0-.633.287.71.71 0 0 0 .153 1.006c2.038 1.49 3.239 3.829 3.239 6.317 0 2.49-1.2 4.834-3.24 6.323a.707.707 0 0 0-.152 1.006.745.745 0 0 0 1.03.144c2.41-1.758 3.831-4.53 3.831-7.472 0-2.94-1.422-5.708-3.83-7.467a.74.74 0 0 0-.398-.144M8.453 6.59a.75.75 0 0 0-.421.157 6.18 6.18 0 0 0-2.4 4.865 6.19 6.19 0 0 0 2.4 4.87.746.746 0 0 0 1.03-.116.707.707 0 0 0-.114-1.006A4.76 4.76 0 0 1 7.1 11.613c0-1.458.683-2.832 1.848-3.741a.706.706 0 0 0 .114-1.013.73.73 0 0 0-.609-.27m7.094 0a.734.734 0 0 0-.608.268.705.705 0 0 0 .114 1.014 4.75 4.75 0 0 1 1.847 3.741 4.75 4.75 0 0 1-1.842 3.747.707.707 0 0 0-.119 1.006.74.74 0 0 0 1.036.117 6.18 6.18 0 0 0 2.394-4.87 6.18 6.18 0 0 0-2.4-4.865v-.001a.75.75 0 0 0-.422-.156M11.94 9.378c-1.228.032-2.227 1.028-2.227 2.237 0 1.229 1.03 2.234 2.286 2.234s2.283-1.005 2.283-2.234c0-1.228-1.027-2.237-2.283-2.237z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }